/**
 * This function is used to assert that a value is never reached. Its primary
 * use case is to catch missed cases at typescript compilation time.
 *
 * For example, the following would result in a type error if a new type was added to the
 * union type and not properly covered:
 *
 * ```typescript
 * type Foo = 'bar' | 'baz';
 *
 * switch (foo) {
 *   case 'bar':
 *     break;
 *   case 'baz':
 *     break;
 *   default:
 *     assertUnreachable(foo); // <- This would result in an error if foo was expanded
 * }
 * ```
 */
export const assertUnreachable = __value => {};